import React, { useState, useCallback } from "react";
import { RiAddLargeFill } from "react-icons/ri";
import debounce from "lodash/debounce";
import {
  useGetColumnNamesQuery,
  useGetSerachColumnsQuery,
  useUpdateWorkbookMutation,
} from "./dataApiSlice";
import { getL1SheetProperty, getWorkbookProperty } from "./WorkbookSlice";
import { useSelector } from "react-redux";
import { Dropdown, DropdownItem } from "flowbite-react";
import CalculatedFieldModal from "./CalculatedFieldModal";
import HierarchyModal from "./HierarchyModal";

import { VscTypeHierarchySub } from "react-icons/vsc";
import { LuSigma } from "react-icons/lu";
import ColumnData from "./ColumnData";
import { useGetDatasourceQuery } from "../dataSource/sql/TablesourceApiSlice";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";

export default function ReduxAside1({ dataSourceID, Sheetid }) {
  console.log(dataSourceID);
  const calculatedFields =
    useSelector((state) => getWorkbookProperty(state, "calculatedFields")) ||
    [];
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || [];
  const query = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "query")
  );
  console.log(query);
  const { rows, groupByFields } = query !== undefined && query;

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [aside1Modal, setAside1Modal] = useState(null);
  const [calculatedUUID, setCalculatedUUID] = useState(null);
  const [hierarchyUUID, setHeirarchyUUID] = useState(null);
  let connnectedDataSets = null;
  // console.log(hierarchyUUID);
  // console.log(calculatedUUID);

  const workbookId = useSelector((state) => getWorkbookProperty(state, "_id"));
  const dataSourcesArray = useSelector((state) =>
    getWorkbookProperty(state, "dataSources")
  );
  const [
    updateWorkbook,
    {
      data: updatedWorkbookData,
      isLoading: isUpdateWorkBookLoading,
      isSuccess: isUpdateWorkBookSuccess,
      isError: isUpdateWorkBookError,
      error: updateWorkBookError,
    },
  ] = useUpdateWorkbookMutation();

  const {
    data: searchedData,
    isSuccess: isSearchSuccess,
    isLoading: isSearchLoading,
    isError: isSearchError,
    error: searchError,
    refetch,
  } = useGetSerachColumnsQuery(
    { dataSourceID, value: debouncedSearchTerm, workbookId },
    {
      skip: !debouncedSearchTerm,
    }
  );

  const {
    data: dataSets,
    isLoading: isDataSetsLoading,
    isError: isDataSetsError,
    error: dataSetsError,
    isSuccess: isDataSetsSuccess,
  } = useGetDatasourceQuery();

  console.log(dataSets);

  console.log(dataSourcesArray);
  if (isDataSetsLoading) {
    connnectedDataSets = <LoadingIndicator />;
  }
  if (isDataSetsError) {
    connnectedDataSets = (
      <button className="font-medium text-red-500">{dataSetsError}</button>
    );
  }
  if (isDataSetsSuccess) {
    connnectedDataSets = dataSets.filter((dSet) =>
      dataSourcesArray.some((arrayItem) => dSet.id === arrayItem)
    );
  }
  console.log(connnectedDataSets);

  const debouncedSetSearchTerm = useCallback(
    debounce((value) => setDebouncedSearchTerm(value), 300),
    []
  );

  const handleSearchColumn = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSetSearchTerm(value);
  };

  const {
    data: columnName,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetColumnNamesQuery(dataSourceID);
  // console.log(columnName);

  if (isLoading) {
    return <LoadingIndicator />;
  }
  if (isError) {
    console.log(error.data.message);
    return (
      <div className="text-red-500 font-medium">
        Error: {error.data.message}
      </div>
    );
  }
  const hierarchyColumns = hierarchy.map((item) => {
    console.log(item);
    if (item.hierarchyColumn?.hierarchyType === "String") {
      return item.hierarchyColumn;
    }
  });
  const mergedColumnsArray = columnName.concat(
    calculatedFields,
    hierarchyColumns
  );

  if (isSuccess) {
    const items =
      debouncedSearchTerm && searchedData ? searchedData : mergedColumnsArray;

    console.log(items);

    return (
      <>
        <main className="pt-1 h-full w-full flex flex-col items-center justify-normal px-1 gap-y-2">
          <section className="flex flex-col items-center justify-start gap-y-[2px] w-full h-[8%]">
            <div className="flex items-center justify-between w-full gap-x-1">
              <h1 className="text-md w-full font-medium text-left text-gray-600">
                Columns
              </h1>
              <Dropdown
                label={
                  <RiAddLargeFill className="text-base text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded h-full" />
                }
                arrowIcon={false}
                className="flex flex-col items-center justify-start"
                placement="right-start"
              >
                <DropdownItem
                  onClick={() => setAside1Modal("calculatedModal")}
                  className="flex items-center justify-left"
                >
                  <LuSigma /> Calculated Field
                </DropdownItem>
                <DropdownItem
                  onClick={() => setAside1Modal("hierarchyModal")}
                  className="flex items-center justify-left"
                >
                  <VscTypeHierarchySub /> Hierarchy
                </DropdownItem>
              </Dropdown>
            </div>
            <input
              autoComplete="off"
              type="search"
              name="query"
              placeholder="search columns..."
              onChange={handleSearchColumn}
              value={searchTerm}
              className="px-3 w-full rounded h-6 border-2 outline-none"
            />
          </section>

          <section className="flex flex-col w-full h-[92%] items-start justify-start gap-1 overflow-y-auto">
            {isSearchError ? (
              <div>{searchError.data.message}</div>
            ) : isSearchLoading ? (
              <LoadingIndicator />
            ) : (
              items.map((data, index) => {
                if (data !== undefined) {
                  return (
                    <ColumnData
                      key={data.uuid || index}
                      data={data}
                      searchedData={searchedData}
                      index={index}
                      setCalculatedUUID={setCalculatedUUID}
                      setHeirarchyUUID={setHeirarchyUUID}
                      dataSourceID={dataSourceID}
                      items={items}
                      updateWorkbook={updateWorkbook}
                      calculatedFields={calculatedFields}
                      hierarchy={hierarchy}
                    />
                  );
                }
              })
            )}
          </section>

          {aside1Modal === "calculatedModal" || calculatedUUID !== null ? (
            <CalculatedFieldModal
              items={items}
              closeModal={() => {
                setCalculatedUUID(null);
                setAside1Modal(null);
              }}
              calculatedFields={calculatedFields}
              calculatedUUID={calculatedUUID}
              updateWorkbook={updateWorkbook}
            />
          ) : null}
          {aside1Modal === "hierarchyModal" || hierarchyUUID !== null ? (
            <HierarchyModal
              closeModal={() => {
                setHeirarchyUUID(null);
                setAside1Modal(null);
              }}
              mergedColumnsArray={mergedColumnsArray}
              dataSourceID={dataSourceID}
              hierarchyUUID={hierarchyUUID}
              hierarchy={hierarchy}
              workbookId={workbookId}
              updateWorkbook={updateWorkbook}
              Sheetid={Sheetid}
              rowsArray={rows}
              groupByFieldsArray={groupByFields}
            />
          ) : null}
        </main>
      </>
    );
  }

  return null; // or any fallback UI if none of the above conditions are met
}
